import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

///
export const TitleHidden = () => {
    const { pub: { title, interaction: { isVisible } } } = useCardContext();

    return !isVisible
        ? (
            <MprcFeedTypography variant="title" component="div" noWrap={true} color="warning">
                <span title={title}>{title}</span>
            </MprcFeedTypography>
        )
        : null;
};
